export default function isConsumerGroupAddress(smtpAddress: string): boolean {
    return !!smtpAddress?.endsWith('@groups.outlook.com');
}
